import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Modal } from 'bootstrap';
import { debounceTime, skip } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ReportsService } from 'src/app/services/reports.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-add-elecetion-data',
  templateUrl: './add-elecetion-data.component.html',
  styleUrls: ['./add-elecetion-data.component.scss']
})
export class AddElecetionDataComponent {
  UserDetails: any;
  targetForm!: FormGroup;
  blockList: any[] = [];
  financialYears: any[] = [];
  circlesList: any[] = [];
  electionData: any[] = [];
  consumerGoodsForm!: FormGroup;
  ElecetionCasesForm!: FormGroup;
  rows: any[] = [];
  months: any[] = [];
  showButton=false
  currentMonth: any = {};
   monthKeyMap: Record<number, string> = {
 1: 'april',
  2: 'may',
  3: 'june',
  4: 'july',
  5: 'august',
  6: 'september',
  7: 'october',
  8: 'november',
  9: 'december',
  10: 'january',
  11: 'february',
  12: 'march'
    };
  constructor(private reportService: ReportsService,private authService: AuthService, private fb: FormBuilder, private toastService: ToastService) {

  }

  ngOnInit(): void {

    this.targetForm = this.fb.group({
      financialYear: ['', Validators.required],
      blockOffice: ['', Validators.required],

    });


    let user: any = this.authService.currentUserValue;
    this.UserDetails = user;

     const today = new Date();
    const currentMonthYear = today.toISOString().slice(0, 7); // format: "2025-09"


         this.consumerGoodsForm = this.fb.group({
      financialYear: [{ value: '2025-2026', disabled: true }, Validators.required],
      blockOffice: [{ value: 'Shimla Urban - Block Office', disabled: true }, Validators.required],
      dataMonth: [{ value: currentMonthYear, disabled: true }, Validators.required],

      urbanControlled: [0, [Validators.required, Validators.min(0)]],
      urbanUnControlled: [0, [Validators.required, Validators.min(0)]],
      ruralControlled: [0, [Validators.required, Validators.min(0)]],
      ruralUnControlled: [0, [Validators.required, Validators.min(0)]],
     
    });
  this.initForm();
    // this.GetConsumerGoods();.
    this.getTargetCount();
    this.GetYearAndMonth();

            switch (this.UserDetails?.roleId) {
      case 13:
       
        break;
      case 1:
             this.targetForm.addControl('circleOffice', new FormControl({
          value: '',
          disabled: false
        }, Validators.required));
       this.getCircle();
        break;
      case 11:
        this.targetForm.controls['blockOffice'].disable();
        this.targetForm.get('blockOffice')?.valueChanges
          .pipe(skip(1)) // ignore the first emit
          .subscribe((val: any) => {
            if (this.targetForm.valid) {
              this.GetElection();
            }
          });
    
        break;
      default:
    }
       this.targetForm.valueChanges
      .pipe(debounceTime(300))  // waits 300ms after last change
      .subscribe(values => {
        if (this.targetForm.valid) {
          this.GetElection();
        }
      });
  }

  initForm(){
     this.ElecetionCasesForm = this.fb.group({
      financialYear: [{ value: '2025-2026', disabled: true }, Validators.required],
      blockOffice: [{ value: 'Shimla Urban - Block Office', disabled: true }, Validators.required],
      dataMonth: [{ value: '', disabled: false }, Validators.required],
      overDue: [{ value: 0, disabled: false }, [Validators.required, Validators.min(0)]],
      electionDue: [0, [Validators.required, Validators.min(0)]],
      electionConducted: [0, [Validators.required, Validators.min(0)]],
      nominatedCommittees: [0, [Validators.required, Validators.min(0)]],
      administratorAppointed: [0, [Validators.required, Validators.min(0)]],
      // administratorAppointedAmount: [0, [Validators.required, Validators.min(0)]],

    });
  }
  
  getTargetCount() {
    let obj = {
      // "action": "GetBIDropdownValue",
      "action": (this.UserDetails?.roleId == 1) ? "GetARDropdownValue" : "GetBIDropdownValue",
      "circleId": this.UserDetails?.iCircleId
    }
    this.reportService.GetTargetCount(obj).subscribe(res => {
      if (res) {
        // this.circlesList = res.data.circles;
        if(this.UserDetails?.roleId !== 1){
       this.blockList = res.data.blocks;
        }
 
          this.financialYears = res.data.financialYears
           if(this.UserDetails?.roleId ==11){
          this.targetForm.controls['blockOffice'].setValue(this.UserDetails?.iBlockId);
            this.targetForm.controls['blockOffice'].disable();
        }
      }
    },
      (error: any) => {
      }
    );
  }
  getCircle() {
  
    this.reportService.getCircle().subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;
        this.circlesList = res.data.circles;
        

    
      }
    },
      (error: any) => {
      }
    );
  }

   GetBlock() {


    let obj = {
      // "action": "GetBIDropdownValue",
      "blockId":0,
      "circleId": this.targetForm.value?.circleOffice
      // "circleId": 0
    }
    
    this.reportService.GetBlock(obj).subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;
        
        this.blockList = res.data?.block;
          this.targetForm.controls['blockOffice'].setValue('');
    
      }
    },
      (error: any) => {
      }
    );
  }
  GetElection() {
    let obj = {
         blockId: this.targetForm.getRawValue().blockOffice.toString(),
        "financialYear": this.targetForm.value?.financialYear?.financialYear
    }
    this.reportService.GetElection(obj).subscribe((res: any) => {
     if (res && res?.data && res?.data.length > 0) {
            let lastRow = res?.data[res?.data.length - 1];
           
            this.electionData =res?.data
            if (Number(lastRow?.dataMonth) != 12 && Number(lastRow?.dataMonth) < 12) {
                     let fyear = this.targetForm.getRawValue()?.financialYear.financialYear
                 let year = (Number(lastRow?.dataMonth) <= 9)? fyear?.split('-')[0] :fyear.split('-')[1] 
               this.currentMonth.key = (Number(lastRow?.dataMonth) + 1).toString();
              this.currentMonth.name = this.monthKeyMap[(Number(lastRow?.dataMonth) + 1)] + ', ' + year; 
              this.showButton = true
                this.initForm();

            } else {
              this.showButton = false
            }


          } else {
         this.electionData = []
           this.initForm();

            this.showButton = true;
            this.currentMonth.name = this.monthKeyMap['1'] + ', ' + this.targetForm.value?.financialYear?.startYear
            this.currentMonth.key = '1';
              this.toastService.showInfo('NO Data Found!')
          }
    },
      (error: any) => {
      }
    );
  }
 GetYearAndMonth() {

    this.reportService.GetYearAndMonth({}).subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;


        // this.financialYears = res.data.financialYears
        this.months = res.data.months


      }
    },
      (error: any) => {
      }
    );
  }
  getMonthName(month: string | number): string {
  const months = [
    'April', 'May', 'June', 'July', 'August', 'September',
    'October', 'November', 'December','January', 'February', 'March',
  ];
  const index = +month - 1;
  return months[index] || 'Unknown';
}

getYearFromFinancialYear(financialYear: string, month: string | number): string {
  const [startYear, endYear] = financialYear.split('-');
  const monthNum = +month;
  return monthNum >= 1 && monthNum <= 9 ? startYear : endYear;
}

getBalance(row: any): number {
  return (row.overDue + row.electionDue - row.electionConducted);
}

  addData(){
let lastItem
if(this.electionData && this.electionData.length >0){
  lastItem =this.electionData[this.electionData.length -1]
}
   
      this.ElecetionCasesForm.patchValue({
  financialYear: this.targetForm.value?.financialYear,
  blockOffice: this.targetForm.getRawValue()?.blockOffice,
   dataMonth:this.currentMonth.key,
   overDue:lastItem ?this.getBalance(lastItem):0
});
 if(lastItem){
  this.ElecetionCasesForm.get('overDue')?.disable();
}
else{
    this.ElecetionCasesForm.get('overDue')?.enable();


}

  }
  

  onSubmit() {
    if (this.ElecetionCasesForm.valid) {
      // 🔑 getRawValue() ensures disabled fields are included
      const payload = this.ElecetionCasesForm.getRawValue();
      // let entryYear = this.reportingYears.find((i) => i?.startYear == payload?.offilneEntryYear)
      let obj = {
      
        
  "blockOfficeId":  payload?.blockOffice,
  "financialYear":  payload?.financialYear?.financialYear?.toString(),
  "dataMonth": payload?.dataMonth,
 
  "overDue": payload?.overDue,
  "electionDue":  payload?.electionDue,
  "electionConducted":  payload?.electionConducted,
  "nominatedCommittees":  payload?.nominatedCommittees,
  "administratorAppointed":  payload?.administratorAppointed,

      "createdBy":  this.edit ?0:this.UserDetails?.id,
        "modifiedBy": this.edit ?this.UserDetails?.id:0,
        id:this.edit ? this.editId:0
   
      }

      this.reportService.AddElection(obj).subscribe((res: any) => {
        if (res) {
          
          if (res?.status == 200) {
            this.toastService.showSuccess(res.message);

            this.hideModal('ConsumerGoodsDistributionDataModal');
            this.ElecetionCasesForm.reset();
            this.ElecetionCasesForm.markAsUntouched();
            this.GetElection();
             this.edit =false
             this.editId = 0;
          }else{
            this.toastService.showError(res.message);
          }


        }
        this.edit =false
      },
        (error: any) => {
        }
      );


    } else {
      this.ElecetionCasesForm.markAllAsTouched();
    }
  }

  edit= false;
  editId=0


    openModal(model: any) {
      const modalElement = document.getElementById(model);
      if (modalElement) {
        const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
        modalInstance.show();
  
      }
    }
  
    hideModal(model: any) {
      const modalElement = document.getElementById(model);
      if (modalElement) {
        const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
        modalInstance.hide();
      }
    }

      editRow(row: any) {

    const electionRow = row;
    const headerData = this.targetForm.getRawValue();
   
this.ElecetionCasesForm.patchValue({
  financialYear:  headerData.financialYear,
  blockOffice:Number(headerData?.blockOffice),
  dataMonth: electionRow.dataMonth,
  overDue: electionRow.overDue,
  electionDue: electionRow.electionDue,
  electionConducted: electionRow.electionConducted,
  nominatedCommittees: electionRow.nominatedCommittees,
  administratorAppointed: electionRow.administratorAppointed,
  // This field doesn't exist in the data, so set to 0 or leave as is
  // administratorAppointedAmount: 0
});


this.editId = electionRow?.id
this.edit =true

    this.openModal('ConsumerGoodsDistributionDataModal');
  }
closeModel(){
  this.ElecetionCasesForm.reset()
  this.ElecetionCasesForm.markAsUntouched()
  this.editId = 0
this.edit =false
}
      DeleteElectionData(id:any){
     this.reportService.DeleteElectionData(id).subscribe((res:any) => {
      if (res) {
    
   if(res?.status ==200){
    this.toastService.showSuccess(res.message);
      this.deleteIndex = 0;
    // this.hideModal();
     this.GetElection();
   }
   
      }
    },
      (error: any) => {
      }
    );
  }
     verifyElectionData(id:any){
     this.reportService.verifyElectionData(id).subscribe((res:any) => {
      if (res) {
  
   if(res?.status ==200){
    this.toastService.showSuccess(res.message);
     this.deleteIndex = 0;
    // this.hideModal();
     this.GetElection();
   }
   
      }
    },
      (error: any) => {
      }
    );
  }
         deleteIndex:any
 setDeleteIndex(index: number) {
    this.deleteIndex = index;
  }
  cancelDelete(){
   this.deleteIndex = 0;

  }
 
}
